var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsersInviteNewActiveIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 7.16659C11.9728 7.16659 13.1667 5.97268 13.1667 4.49992C13.1667 3.02716 11.9728 1.83325 10.5001 1.83325M11.8334 15.1666H13.7001C14.8783 15.1666 15.8334 14.2115 15.8334 13.0333C15.8334 11.2659 14.4007 9.83325 12.6334 9.83325H11.8334M8.50008 4.49992C8.50008 5.97268 7.30617 7.16659 5.83342 7.16659C4.36066 7.16659 3.16675 5.97268 3.16675 4.49992C3.16675 3.02716 4.36066 1.83325 5.83342 1.83325C7.30617 1.83325 8.50008 3.02716 8.50008 4.49992ZM3.30008 15.1666H8.36675C9.54496 15.1666 10.5001 14.2115 10.5001 13.0333C10.5001 11.2659 9.06739 9.83325 7.30008 9.83325H4.36675C2.59944 9.83325 1.16675 11.2659 1.16675 13.0333C1.16675 14.2115 2.12187 15.1666 3.30008 15.1666Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsersInviteNewActiveIcon);
export default ForwardRef;